import { z } from 'zod';

export const productSchema = z.object({
  name: z
    .string()
    .min(1, 'validation.required')
    .min(3, 'validation.minLength')
    .max(200, 'validation.maxLength'),
  description: z
    .string()
    .max(5000, 'validation.maxLength')
    .optional(),
  price: z
    .number()
    .min(0, 'validation.positiveNumber'),
  comparePrice: z
    .number()
    .min(0, 'validation.positiveNumber')
    .optional(),
  sku: z
    .string()
    .max(100, 'validation.maxLength')
    .optional(),
  stock: z
    .number()
    .int()
    .min(0, 'validation.positiveNumber'),
  categoryId: z
    .string()
    .optional(),
  shopId: z
    .string()
    .min(1, 'validation.required'),
  status: z
    .enum(['active', 'inactive', 'draft'])
    .default('draft'),
  images: z
    .array(z.string().url('validation.invalidUrl'))
    .max(10)
    .optional(),
});

export type ProductFormData = z.infer<typeof productSchema>;

export const productVariantSchema = z.object({
  name: z
    .string()
    .min(1, 'validation.required')
    .max(100, 'validation.maxLength'),
  sku: z
    .string()
    .max(100, 'validation.maxLength')
    .optional(),
  price: z
    .number()
    .min(0, 'validation.positiveNumber'),
  stock: z
    .number()
    .int()
    .min(0, 'validation.positiveNumber'),
  attributes: z
    .record(z.string(), z.string())
    .optional(),
});

export type ProductVariantFormData = z.infer<typeof productVariantSchema>;
